// @flow

import 'core-js/fn/regexp/escape';

/**
 * Retreive cookie.
 */
export function getCookie(key: string): ?string {
  // $FlowFixMe Non-standard RegExp method
  const regex = new RegExp(`(?:^|;)(?:\\s*)${RegExp.escape(key)}=([^;]+)`);
  const match = document.cookie.match(regex);

  if (match && match[1]) {
    return decodeURIComponent(match[1]);
  }

  return null;
}

export function doNotSell(): boolean {
  const cookieBoolean = getCookie('do_not_sell');
  if (cookieBoolean) {
    return JSON.parse(cookieBoolean);
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/lib/utils.js